import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IVolunteerShift } from './models';
import { invalidateVolunteerShifts } from './useVolunteerShifts';

export const useUpdateVolunteerShiftMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: IVolunteerShift) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			shift,
			impersonationContext,
		}: {
			shift: IVolunteerShift;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<IVolunteerShift>(
				Api.ImpersonationBroker.composeApiUrl({ impersonationContext, urlPath: `volunteering/shifts/${shift.id}` }),
				'PUT',
				shift
			),
		onSuccess: data => {
			invalidateVolunteerShifts(data?.volunteerActivityId);
			onSuccess?.(data);
		},
		onError,
	});
};
